import { Translation } from '../../api';
import { ActionTypes } from '../actions/types';

const initialState: Array<Translation> = [];

export default function (
  state = initialState,
  action: { type: ActionTypes; payload?: Translation[] }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.FETCH_TRANSLATIONS:
      return payload;
    default:
      return state;
  }
}
